import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Home365PopupComponent } from './home365-popup.component';
import {Home365LoaderModule} from "../loader/home365-loader.module";
import {MatIconModule} from "@angular/material/icon";
import {PortalModule} from "@angular/cdk/portal";

@NgModule({
    imports: [CommonModule, Home365LoaderModule, MatIconModule, PortalModule],
  declarations: [
    Home365PopupComponent
  ],
  exports: [
    Home365PopupComponent
  ],
})
export class Home365PopupModule {}
